<!-- HEETER -->
<div class='quick-link'>
  <a href="javascript:void(0)" (click)="submitHeeterSSOForm();" class="external-link">
    {{ heeterLabel || 'Order Supplies-Over 65 (Heeter/ShopPro)' }}
    <span class="material-symbols-outlined">open_in_new</span>
  </a>
</div>